import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = { max: Number }

  connect() {
    this.encoder = new TextEncoder()
    this.debounceTimeout = null
    this.updateCounter()
  }

  disconnect() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  update() {
    // Debounce: wait 500ms after last input before calculating
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
    this.debounceTimeout = setTimeout(() => this.updateCounter(), 500)
  }

  updateCounter() {
    const current = this.encoder.encode(this.inputTarget.value).length
    const remaining = this.maxValue - current
    const percentage = (current / this.maxValue) * 100

    this.counterTarget.textContent = this.formatCounter(current, remaining)

    // Hide counter when usage is below 80%, show when at or above
    if (percentage < 80) {
      this.counterTarget.classList.add("hidden")
    } else {
      this.counterTarget.classList.remove("hidden")

      // Update color based on usage
      if (percentage > 90) {
        this.counterTarget.classList.remove("text-amber-600", "text-stone-500")
        this.counterTarget.classList.add("text-red-600")
      } else {
        this.counterTarget.classList.remove("text-red-600", "text-stone-500")
        this.counterTarget.classList.add("text-amber-600")
      }
    }
  }

  formatCounter(current, remaining) {
    const currentKB = (current / 1024).toFixed(0)
    const maxMB = (this.maxValue / (1024 * 1024)).toFixed(0)

    if (remaining < 0) {
      const overKB = Math.abs(remaining / 1024).toFixed(0)
      return `${currentKB} KB / ${maxMB} MB (${overKB} KB over limit)`
    }

    return `${currentKB} KB / ${maxMB} MB`
  }
}
